import { render } from "./NavigationStepButtons.vue?vue&type=template&id=52c16270"
import script from "./NavigationStepButtons.vue?vue&type=script&lang=js"
export * from "./NavigationStepButtons.vue?vue&type=script&lang=js"

import "./NavigationStepButtons.vue?vue&type=style&index=0&id=52c16270&lang=scss"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__